import React, { memo, useEffect, useState } from "react";
import styles from "./SignUpModal.module.css";
import axios from "axios";
import { DEV_API } from "../Common/Constant";
import PasswordInput from "../CustomComp/pswdInput/PasswordInput";
import { isShallowEqual } from "../Common/Common";
import VerificationModal from "./VerificationModal";
import FullScreenLoader from "../Common/FullScreenLoader";

const initErr = {};

const SignUpModal = ({ onBack }) => {
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
    password: "",
    /* address1: "",
    address2: "",
    pincode: "", */
  });
  const [errors, setErrors] = useState(initErr);
  const [signUpErr, updateSignUpErr] = useState("");
  const [showVerifyUser, toggleVerifyUser] = useState(false);
    const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    const err = structuredClone(errors);
    if (errors.firstName && form.firstName) {
      delete err.firstName;
    }
    /* if (errors.address1 && form.address1) {
      delete err.address1;
    } */
    if (errors.password && form.password) {
      delete err.password;
    }
    if (errors.mobile && form.mobile) {
      if (/^[6-9]\d{9}$/.test(form.mobile)) {
        delete err.mobile;
      } else {
        err.mobile = "Enter a valid 10-digit Indian mobile number";
      }
    }
    if (errors.email && form.email) {
      if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) {
        delete err.email;
      } else {
        err.email = "Invalid email address";
      }
    }
    if (errors.pincode && form.pincode) {
      if (/^\d{6}$/.test(form.pincode)) {
        delete err.pincode;
      } else {
        err.pincode = "Enter a valid 6-digit Indian pincode";
      }
    }
    if (!isShallowEqual(err, errors)) {
      setErrors(err);
    }
  }, [form]);

  const validate = () => {
    const errs = {};

    if (!form.firstName) errs.firstName = "First name is required";
    if (!form.email) errs.email = "Email is required";
    if (!form.mobile) errs.mobile = "Mobile number is required";
    // if (!form.address1) errs.address1 = "Address Line 1 is required";
    if (!form.password) errs.password = "Password is required";

    if (form.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) {
      errs.email = "Invalid email address";
    }

    if (form.mobile && !/^[6-9]\d{9}$/.test(form.mobile)) {
      errs.mobile = "Enter a valid 10-digit Indian mobile number";
    }

    if (form.pincode && !/^\d{6}$/.test(form.pincode)) {
      errs.pincode = "Enter a valid 6-digit Indian pincode";
    }

    if (!isShallowEqual(errs, errors)) {
      setErrors(errs);
    }
    return Object.keys(errs).length === 0;
  };

  const getErrorList = () => {
    const values = Object.values(errors).filter((val) => val !== "");
    const result = values.length ? values.join(". ") + "." : "";
    return result;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const setVerifyUser = () => {
    toggleVerifyUser(!showVerifyUser);
  }

  const onSignup = (e) => {
    e.preventDefault();
    if (validate()) {
      setLoading(true);
      const req = { ...form };
      axios
        .post(`${DEV_API}/users/register`, req)
        .then(() => {
          setVerifyUser();
        })
        .catch((err) => {
          console.error("err----", err);
          updateSignUpErr(err?.response?.data?.error);
        }).finally(()=>{
          setLoading(false);
        });
    }
  };

  const signUpForm = () => {
    return (
      <>
        <div className={styles.signUpFormHeader}>
          <h2 className={`m0`}>Sign Up</h2>
          <button className={styles.backBtn} onClick={onBack}>
            ← Back to Login
          </button>
        </div>
        <div className={styles.signUpFormContainer}>
          <form id="signupForm" onSubmit={onSignup} className={styles.form}>
            <div className={styles.row}>
              <div className={styles.formGroup}>
                <label>First Name *</label>
                <input
                  name="firstName"
                  value={form.firstName}
                  onChange={handleChange}
                />
                {errors.firstName && (
                  <p className={styles.error}>{errors.firstName}</p>
                )}
              </div>
              <div className={styles.formGroup}>
                <label>Last Name</label>
                <input
                  name="lastName"
                  value={form.lastName}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className={styles.formGroup}>
              <label>Email *</label>
              <input name="email" value={form.email} onChange={handleChange} />
              {errors.email && <p className={styles.error}>{errors.email}</p>}
            </div>

            <div className={styles.formGroup}>
              <label>Mobile Number *</label>
              <input
                name="mobile"
                value={form.mobile}
                onChange={handleChange}
              />
              {errors.mobile && <p className={styles.error}>{errors.mobile}</p>}
            </div>

            <div className={styles.formGroup}>
              <label>Password *</label>
              <PasswordInput
                name="password"
                value={form.password}
                onChange={handleChange}
              />
              {errors.password && (
                <p className={styles.error}>{errors.password}</p>
              )}
            </div>

            {/* <div className={styles.formGroup}>
              <label>Address Line 1 *</label>
              <input
                name="address1"
                value={form.address1}
                onChange={handleChange}
              />
              {errors.address1 && (
                <p className={styles.error}>{errors.address1}</p>
              )}
            </div>

            <div className={styles.formGroup}>
              <label>Address Line 2</label>
              <input
                name="address2"
                value={form.address2}
                onChange={handleChange}
              />
            </div>

            <div className={styles.formGroup}>
              <label>Pincode</label>
              <input
                name="pincode"
                value={form.pincode}
                onChange={handleChange}
              />
              {errors.pincode && (
                <p className={styles.error}>{errors.pincode}</p>
              )}
            </div> */}
          </form>
        </div>
        <div className={styles.signUpFormFooter}>
          <button
            form="signupForm"
            type="submit"
            className={styles.submitButton}
          >
            Register
          </button>
          {Object.keys(errors).length != 0 && (
            <div className={styles.errorList}>{getErrorList()}</div>
          )}
          {signUpErr && (
            <div className={`bolder ${styles.errorList}`}>{signUpErr}</div>
          )}
        </div>
      </>
    );
  };

  if (showVerifyUser) return <VerificationModal onBack={setVerifyUser} onSignup={onSignup} form={form} />;

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>{signUpForm()}</div>
      {isLoading && <FullScreenLoader />}
    </div>
  );
};

SignUpModal.whyDidYouRender = true;

export default memo(SignUpModal);
